import { TimelineRepository } from 'api/liveShopping/domain';
import type { Timeline } from '../entities';

export class GetTimeLineService {
  constructor(private timelineRepository: TimelineRepository) {}
  execute(account: string, idEvent: string): Promise<Timeline[]> {
    return this.timelineRepository.getTimeLine(account, idEvent);
  }
}
